(function ($) {
  'use strict';

  /**
   * Accordion Controls
   * - a11y - Adds aria attributes
   * - Supports multiple accordion groups on a single page
   */

  // Track accordion group index for el ids
  var group_index = 0;

  $.fn.accordionControls = function () {
    group_index++;
    var $accordion_group = $(this);
    var $group_buttons = $accordion_group.find( '.accordion-title > button' );
    var $group_slides = $accordion_group.find( '.accordion-content' );

    // Prep Accordion Group
    $accordion_group.addClass( 'is-accordion-enabled' );
    $group_slides.slideUp();

    // Prep Accordion Buttons
    $group_buttons.each(function ( index ) {
      var $this_button = $(this);
      var $this_slide = $this_button
        .parent( '.accordion-title' )
        .next( '.accordion-content' );
      var button_index = index + 1;
      var button_id = 'accordion-button-' + group_index + '-' + button_index;
      var region_id = 'accordion-region-' + group_index + '-' + button_index;

      // Prep button group ID & aria attrs
      $this_button
        .attr( 'aria-controls', region_id )
        .attr( 'aria-expanded', 'false' )
        .attr( 'id', button_id );

      // Prep slide group ID & aria attrs
      $this_slide
        .attr( 'role', 'region' )
        .attr( 'aria-labelledby', button_id )
        .attr( 'id', region_id );
    });

    // Toggle on click
    $group_buttons.on('click.accordionControls', function () {
      var $this_button = $(this);
      var $this_slide = $( '#' + $this_button.attr( 'aria-controls' ) );

      toggle_accordion_group(
        $this_button,
        $this_slide,
        $group_buttons,
        $group_slides
      );

      return false;
    });

    return this;
  };


  /**
   * Toggle Accordion Group
   * @param {jQuery} $button The title to click or press
   * @param {jQuery} $slide The content to open
   * @param {jQuery} $all_buttons All title to toggle off
   * @param {jQuery} $all_slides All content to toggle off
   */
  function toggle_accordion_group( $button, $slide, $all_buttons, $all_slides ) {
    var is_expanded = $button.attr( 'aria-expanded' ) === 'true';

    // Media Query Check - Reduced Motion
    var mql_reduced_motion = window.matchMedia( '(prefers-reduced-motion: reduce)' );
    var is_reduced_motion = mql_reduced_motion === true
      || mql_reduced_motion.matches === true;

    // Enable / Disable Animation
    var animation_duration = ! is_reduced_motion ? 400 : 0;

    // Close all slides
    $all_slides.slideUp( animation_duration );
    $all_buttons.attr( 'aria-expanded', 'false' );

    // Open this slide
    if ( ! is_expanded ) {
      $slide.slideDown( animation_duration );
      $button.attr( 'aria-expanded', 'true' );
    }
  }

})(jQuery);
